function EmbedPresetShareController($q, $scope, $element, $rootScope, eventSender, socket, serviceUtility, $filter, $location) {
	var pid = LOGPRESSO.process.getPid();
	$scope.dataApiKeys = [];
	$scope.dataMembers = [];
	$scope.currentUser = null;
	$scope.currentPreset = null;
	$scope.isOnCreate = false;

	// TODO:
	// 5. locale 작업

	function init(type) {
		$scope.dataApiKeys = [];
		$scope.dataMembers = [];

		getApiKeys().then(function(apikeys) {
			$scope.dataApiKeys = apikeys;
			return getUsers();
		}).then(function(users) {
			var dataUsers = users,
				 members = dataUsers.filter(function(dataUser) {
				 	return dataUser.ext.admin.role.name === 'member';
				 });

			if(members.length) {
				if($scope.dataApiKeys.length) {
					members.forEach(function(member) {
						$scope.dataApiKeys.forEach(function(dataApiKey){
							if(member.login_name === dataApiKey.name) {
								member.apikey = dataApiKey.guid;
							}
						});
					});
				}
				// only works for member accounts
				$scope.dataMembers = members;

				if(type !== 'refresh') {
					$('.mdlEmbedPresetShare')[0].showDialog();
				}
			}else {
				// no member exist modal
				shareEmbedPresetFailed({}, $filter('translate')('$S_msg_NoMemberExistError'));
			}
		})
	}

	$scope.refreshMemberList = function() {
		// initialize when user list loaded
		init('refresh');
	}

	eventSender.dashboard.openShareEmbedPresetWizard = function(currentPreset) {
		$scope.go(0);
		$scope.isOnCreate = false;
		$scope.currentUser = null;
		$scope.currentPreset = currentPreset;

		// initialize when user list loaded
		init();
	}

	$scope.go = function(page, options) {
		if(angular.isDefined(options)) {
			if(angular.isFunction(options.pre)) {
				$scope.isOnCreate = true;
				options.pre();
			}
		}

		if(!$scope.isOnCreate) {
			var elc = $element.find('.wizard-contents li').removeClass('active')[page];
			var el = $element.find('.wizard li.wiz-step').removeClass('active')[page];
			$(elc).addClass('active');
			$(el).addClass('active');
		}
	}

	$scope.createEmbedPresetUrl = function() {
		$scope.embedPresetUrl = undefined;
		var protocol = $location.protocol() + '://',
			host = $location.host(),
			port = $location.port() === undefined ? '' : ':' + $location.port(),
			path = '/logpresso/dashboard/',
			presetGUID = $scope.currentPreset.guid,
			apikeyString = '?apikey=',
			apikey = $scope.currentUser.apikey,
			isUserGranted = checkGrant($scope.currentUser, $scope.currentPreset),
			deferred = $q.defer(),
			url = undefined;

		url = protocol + host + port + path;

		if(!apikey) {
			var name = $scope.currentUser.login_name,
				 guid = serviceUtility.generateType1();

			createApiKey(name, guid).then(function(m) {
				apikey = guid;

				if(isUserGranted) {
					$scope.embedPresetUrl = url + presetGUID + apikeyString + apikey;
				}else {
					if(angular.isDefined($scope.currentPreset)) {
						if(!$scope.currentPreset.read_grants) {
							$scope.currentPreset.read_grants = 	[];
						}
						$scope.currentPreset.read_grants.push($scope.currentUser.login_name);
					}
				}
				return grantPreset();
			}).then(function() {
				$scope.embedPresetUrl = url + presetGUID + apikeyString + apikey;
			});
		}else{
			if(isUserGranted) {
				$scope.embedPresetUrl = url + presetGUID + apikeyString + apikey;
				// return ;
			}else {
				if(angular.isDefined($scope.currentPreset)) {
					if(!$scope.currentPreset.read_grants) {
						$scope.currentPreset.read_grants = 	[];
					}
					$scope.currentPreset.read_grants.push($scope.currentUser.login_name);
				}

				grantPreset()
				.then(function(m) {
					$scope.embedPresetUrl = url + presetGUID + apikeyString + apikey;
				});
			}
		}
		$scope.isOnCreate = false;
	}


	function checkGrant(currentUser, currentPreset) {
		if(!currentPreset.read_grants) {
			return false;
		}

		var loginName = currentUser.login_name,
			 readGrant = currentPreset.read_grants,
			 isExist = undefined;

		isExist = readGrant.some(function(grantUser) {
			return grantUser === loginName;
		});

		if(isExist) {
			return true;
		}else{
			return false;
		}
	}

	$scope.stopPropagation = function(e) {
		e.preventDefault();
		e.stopPropagation();
	}

	$scope.select = function(user) {
		$scope.currentUser = user;
		// console.log('selected User', $scope.currentUser, $scope.currentPreset);
	}

	$scope.copyPresetUrl = function(e) {
		$('.mdlEmbedPresetShare .wizard .url-msg').copyNodeText();
		notify('success', $filter('translate')('$S_msg_CopyInfoSuccess'), true);
	}

	function shareEmbedPresetFailed(m, raw) {
		$('.mdlEmbedPresetShare')[0].hideDialog();
		$scope.isOnCreate = false;
		// console.log('error', event, args);
		$scope.errorType = m.errorType;
		$scope.errorCode = angular.isArray(raw) ? raw[0].errorCode : raw;
		// $scope.$apply();
		$('.mdlShareEmbedPresetError')[0].showDialog();
	}


	function grantPreset() {
		var deferred = $q.defer();
		socket.send("com.logpresso.core.msgbus.WallPlugin.setPreset", $scope.currentPreset, pid, true)
		.success(function() {
			deferred.resolve(true);
		}).failed(shareEmbedPresetFailed);

		return deferred.promise;
	}

	function getApiKeys() {
		var deferred = $q.defer();
		socket.send('com.logpresso.core.msgbus.ApikeyPlugin.getApiKeys', {}, pid)
		.success(function(m) {
			deferred.resolve(m.body.apikeys);
		}).failed(shareEmbedPresetFailed);

		return deferred.promise;
	}

	function getUsers() {
		var deferred = $q.defer();
		socket.send('org.araqne.dom.msgbus.UserPlugin.getUsers', {}, pid)
		.success(function(m) {
			deferred.resolve(m.body.users);
		}).failed(shareEmbedPresetFailed);

		return deferred.promise;
	}

	function createApiKey(name, guid) {
		var deferred = $q.defer();
		socket.send('com.logpresso.core.msgbus.ApikeyPlugin.createApiKey', {'name': name, 'guid': guid}, pid)
		.success(function(){
			deferred.resolve(true);
		}).failed(shareEmbedPresetFailed);

		return deferred.promise;
	}

}

module.exports = EmbedPresetShareController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/EmbedPresetShareController.js